<div class="w-100 pt-3" *ngIf="taskTree.length > 0">
  <div class="border-top mx-2"></div>
  <div
    class="d-flex flex-column justify-content-center align-items-start w-100 px-3"
  >

    <!-- Classification Title -->
    <div class="py-2">
        <span class="text-complementary-color-a fw-bold text-sub-title">
          {{language?.workflowStepManagement || 'workflow step management'}}:
        </span>
    </div>

    <!-- Classification Title -->
    <div class="py-2">
        <span class="text-complementary-color-a text-sub-title">
          {{language?.steps || 'steps' | titlecase}}:
        </span>
    </div>

    <div class="d-flex px-0 flex-column w-100">

      <div class="flex-grow-1 overflow-y-auto">
        <div
          *ngFor="let task of taskTree; let taskIndex=index"
          class="pb-2 d-flex flex-column justify-content-center align-items-start"
        >
          <div class="d-flex justify-content-start align-items-start pb-2 w-100">
            <div
              class="main-task d-flex justify-content-center align-items-center"
            >
              <div class="custom-arrow-right"></div>
              <span class="ms-1 text-normal fw-semibold">{{taskIndex + 1}}.</span>
            </div>
            <div class="flex-grow-1 d-flex justify-content-start align-items-center ms-1">
                <span class="text-normal fw-semibold user-select-none">
                  {{ task.label }}
                </span>
            </div>
            <div class="d-flex justify-content-start align-items-center">
              <span
                class="custom-marker {{task.status.key}}"
                [style.background-color]="task.status.color"
                [style.border-color]="task.status.key !== 'mixed' ? task.status.color: '#8D8D8D'"
              ></span>
            </div>
          </div>



          <ng-container *ngTemplateOutlet="recursiveTree; context:{ itemList: task.children, parentIndex: taskIndex }"></ng-container>
        </div>
      </div>

    </div>

  </div>
</div>


<ng-template #recursiveTree let-itemList="itemList" let-parentIndex="parentIndex" let-root="root">
  <div
    *ngFor="let task of itemList; let index=index"
    class="ps-1 pe-0 w-100 d-flex align-items-center flex-row pointer dropdown"
    [triggers]="!task?.editable?.value ? 'mouseenter:mouseleave' : ''"
    container="body"
    placement="left"
    boundariesElement="viewport"
    [popover]="popTemplate"
    containerClass="task-warning"
    [popoverContext]="task?.editable"
  >
<!--      &lt;!&ndash; Step number &ndash;&gt;-->
<!--      <div class="d-flex justify-content-start align-items-start py-1 pe-1">-->
<!--        <label-->
<!--          class="text-normal user-select-none"-->
<!--          [class.text-neutral-color-e]="!task.editable.value"-->
<!--        >-->
<!--          {{ parentIndex+1 }}.{{index+1}}-->
<!--        </label>-->
<!--      </div>-->

    <!-- Step label -->
    <div
      class="ps-2 flex-grow-1 d-flex justify-content-start align-items-start py-1 me-1 w-100 rounded-pill hover:menu-selected"
      [class.hover:menu-selected]="task.editable.value"
      [attr.data-bs-toggle]="task.editable.value ? 'dropdown' : ''"
      aria-expanded="false"
    >
      <label
        class="text-normal user-select-none"
        [class.text-neutral-color-e]="!task.editable.value"
        [class.pointer] = "task.editable.value"
        [class.not-allowed-cursor] = "!task.editable.value"
      >
        {{ parentIndex+1 }}.{{index+1}} {{task.label}}
      </label>
    </div>


    <!-- Status color ball -->
    <div
      *ngIf="loadingBulkStatusTaskResult !== task.id"
      class="d-flex justify-content-end align-items-center py-1"
    >
      <span
        class="custom-marker {{task.status.key}}"
        [style.background-color]="task.status.color"
        [style.border-color]="task.status.key !== 'mixed' ? task.status.color: '#8D8D8D'"
      ></span>
    </div>

    <!-- Loader -->
    <div
      style="min-width: 15px"
      *ngIf="loadingBulkStatusTaskResult === task.id"
      class="spinner-grow spinner-grow-sm text-complementary-color-a" role="status"
    ></div>

    <!-- Menu for status change-->
    <ul
      class="dropdown-menu p-2 flex-column gap-2" style="min-width: auto !important;"
    >
      <ng-container *ngFor="let state of task.allowedFullStatus; let menuIndex=index; let stateFirst=first; let stateLast=last">
        <li
          [class.mb-1]="!stateLast"
        >
          <div class="d-flex justify-content-start align-items-center">
            <div
              style="width: 16px; height: 16px"
              class="rounded-circle me-2 d-flex justify-content-center align-items-center"
              [style.background-color]="state.color || 'transparent'"
              [style.border] = "'1px solid ' + state.color || 'transparent'"
            >
              <span
                *ngIf="!state?.icon"
                style="width: 12px; height: 12px; border: 1px solid white"
                class="rounded-circle"
              ></span>
              <span *ngIf="state?.icon" class="material-symbols-outlined text-mini">
                {{state.icon}}
              </span>

            </div>
            <div
              class="flex-grow-1 d-flex justify-content-center px-3 rounded-pill hover:menu-selected"
              style="padding-top: 2px; padding-bottom: 2px"
              [style.background-color]="state.color || 'transparent'"
              (click)="taskStatusChange(task.id, state)"
            >
              <span class="text-mini" >{{state.label}}</span>
            </div>
          </div>
        </li>
      </ng-container>
    </ul>

    <!-- Recursive template -->
    <ng-container *ngTemplateOutlet="recursiveTree; context:{ itemList: task.children, parentIndex: index }"></ng-container>
  </div>



</ng-template>

<ng-template #popTemplate let-message="message">
    <div class="d-flex justify-content-start align-items-center pb-2">
    <span style="margin-left: -2px" class="material-symbols-sharp text-title text-warning p-0 me-2">
      gpp_bad
    </span>
      <span class="text-sub-title fw-semibold">{{language.bulkTaskPermissionHeader}}</span>
    </div>
    <div class="text-normal" *ngIf="message" [innerHTML]="message"></div>

</ng-template>
